import { useAzureAuth } from "@datamole/wds-azure-auth";
import { type ReactNode } from "react";

import { config } from "@/config";
import { AuthGetUser } from "@/features/auth/AuthGetUser";
import { AuthAzureGuard } from "@/features/auth/AuthGuard/AuthAzureGuard";
import { AuthNotImplementedPage } from "@/features/auth/AuthGuard/AuthNotImplementedPage";
import { LoginPage } from "@/pages/LoginPage";
import { useAppSelector } from "@/store";

type Props = {
    children: ReactNode;
};

export const AuthGuard = ({ children }: Props) => {
    const { isAuthenticated, authStrategy } = useAppSelector((state) => {
        return state.auth;
    });

    const { user: azureAuthUser, isInteractionInProgress } = useAzureAuth();

    // ADFS
    if (isAuthenticated && authStrategy === "adfs") {
        return <AuthGetUser>{children}</AuthGetUser>;
    }

    // // Azure Ad
    if (config.AZURE_AUTH_ENABLED && (azureAuthUser || isInteractionInProgress)) {
        return (
            <AuthAzureGuard>
                {/* // TODO: Remove after implemented user fetching for Azure Auth */}
                <AuthNotImplementedPage />
                {/* <AuthGetUser>{children}</AuthGetUser> */}
            </AuthAzureGuard>
        );
    }

    // Not authenticated
    return <LoginPage />;
};
